import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getTeacherClasses } from '../lib/api';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Users, ChevronRight, BarChart3, Loader2 } from 'lucide-react';
import { usePageTitle } from '../hooks/usePageTitle';

export default function ClassTracking() {
  usePageTitle('Suivi pédagogique');
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await getTeacherClasses();
        setClasses(res.data);
      } catch {}
      setLoading(false);
    })();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-24" data-testid="tracking-loading">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="space-y-6 animate-fade-in" data-testid="class-tracking-page">
      <div>
        <h1 className="text-3xl font-black tracking-tight">Suivi pédagogique</h1>
        <p className="text-muted-foreground mt-1">Sélectionnez une classe pour consulter son tableau de bord.</p>
      </div>

      {classes.length === 0 ? (
        <Card className="bg-card border-border">
          <CardContent className="text-center py-16">
            <Users className="w-12 h-12 mx-auto mb-4 text-muted-foreground" strokeWidth={1} />
            <p className="text-muted-foreground">Aucune classe créée.</p>
            <Link to="/students">
              <Button className="mt-4 bg-primary text-primary-foreground">Créer une classe</Button>
            </Link>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {classes.map((c) => (
            <Link key={c.class_id} to={`/tracking/${c.class_id}`} data-testid={`class-card-${c.class_id}`}>
              <Card className="bg-card border-border hover:border-primary/50 transition-all duration-200 hover:translate-y-[-2px] cursor-pointer h-full">
                <CardContent className="p-5 flex flex-col justify-between h-full">
                  <div>
                    <div className="flex items-center justify-between mb-3">
                      <BarChart3 className="w-5 h-5 text-primary" strokeWidth={1.5} />
                      <ChevronRight className="w-4 h-4 text-muted-foreground" />
                    </div>
                    <p className="text-lg font-bold">{c.nom}</p>
                    <p className="text-sm text-muted-foreground">{c.niveau || ''} {c.annee || ''}</p>
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
